<template>
  <v-radio-group v-model="calculatedValue" :disabled="disabled" :label="label">
    <v-radio v-for="(item, idx) in items" :key="idx" :disabled="disabled" :value="item.type || '_'" class="mb-4">
      <template v-slot:label>
        <div>
          <div><strong>{{ item.text }}</strong></div>
          <div>{{ item.tooltip }}</div>
        </div>
      </template>
    </v-radio>
  </v-radio-group>   
</template>

<script>
export default {
  name: "RadioButtonGroup",
  components: {
  },
  props: {
    value: { type: null, default: null },
    label: { type: String, default: null },
    items: { type: Array, default: null },
    disabled: { type: Boolean, default: false },
  },
  data: function() {
    return {
      rendered: null,
    };
  },
  async mounted() {
      
  },
  methods: {
      
  },
  computed: {
    calculatedValue:{
      get () {
        return !this.value ? '_' : this.value
      },
      set (value) {
        let val = value == '_' ? null : value;
        //console.log('/// toggle value changing to', val);
        this.$emit('input', val);
      }
    },      
  },
  watch: {
      
  }
};
</script>

<style lang="scss">
</style>